import { Trans, useTranslation } from "react-i18next";

export function NotCompatibleBrowser() {
  const { t } = useTranslation("errors", { keyPrefix: "browserIncompatible" });

  return (
    <div>
      <h1>{t("title")}</h1>
      <p>
        <Trans
          components={[
            <a href="https://caniuse.com/wasm" key="link" target="_blank" />,
          ]}
          i18nKey="browserIncompatible.message"
          ns="errors"
        />
      </p>
    </div>
  );
}
